import Vue from 'vue';
import Router from 'vue-router';
import Ping from '../components/Ping.vue';
import Exclusion from '../components/Exclusion.vue';
import Extract from '../components/Extract.vue';
import Dashboard from '../components/Dashboard.vue';
import Uploadfile from '../components/Uploadfile.vue';
import Home from '../components/Home.vue';
import store from '../store'; // your vuex store

Vue.use(Router);

const ifAuthenticatedGdpr = (to, from, next) => {
  if (store.getters.isAuthenticated_gdpr) {
    next();
    return;
  }
  next('/');
};

const ifAuthenticatedDashboard = (to, from, next) => {
  if (store.getters.isAuthenticated_dashboard) {
    next();
    return;
  }
  next('/');
};

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/ping',
    name: 'Ping',
    component: Ping,
  },
  {
    path: '/exclusion',
    name: 'Exclusion',
    component: Exclusion,
    beforeEnter: ifAuthenticatedGdpr,
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    beforeEnter: ifAuthenticatedDashboard,
  },
  {
    path: '/uploadfile',
    name: 'Uploadfile',
    component: Uploadfile,
    beforeEnter: ifAuthenticatedDashboard,
  },
  {
    path: '/extract',
    name: 'Extract',
    component: Extract,
    beforeEnter: ifAuthenticatedGdpr,
  },
  ],
});
